export default "__VITE_ASSET__CFfPPLkd__"